import React, { useState, useEffect, useRef } from "react";

const CommonDropdownMenuThree = ({
  options = [],
  suboption = [],
  rawselectedOption,
  handleOptionSelect = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (rawselectedOption) {
      setSelectedOption(rawselectedOption);
    }
  }, [rawselectedOption]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    handleOptionSelect(option);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown-wrapper position-relative w-100" ref={dropdownRef}>
      {/* Dropdown header */}
      <div
        className="dropdown-header d-flex justify-content-between align-items-center px-3 py-2"
        onClick={toggleDropdown}
      >
        <span className="selected-option text-truncate">{selectedOption}</span>
        <span className="icon">
          <i className={`fa-solid ${isOpen ? "fa-caret-up" : "fa-caret-down"}`} />
        </span>
      </div>

      {/* Dropdown content */}
      {isOpen && (
        <div className="dropdown-content">
          {options.map((option, index) => (
            <div
              key={index}
              className="dropdown-item px-3 py-2"
              onClick={() => handleOptionClick(option)}
            >
              <div className="menu fw-bold">{option}</div>
              {suboption[index] && (
                <div className="subtitle text-muted small">{suboption[index]}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommonDropdownMenuThree;
